<template>
  <div class="container">
    <div class="mt-5">
      <h2>會診清單</h2>
    </div>
    <form class="row justify-content-center" @submit.prevent="search">
      <div>
        <label>ID Number</label>
        <input
          type="text"
          id="id_number"
          class="form-control"
          placeholder="ID Number"
          required
          autofocus
          v-model="user.id_number"
        />
        <div class="mt-4 text-center">
          <button class="btn btn-lg btn-primary btn-block" type="submit">
            查詢
          </button>
        </div>
      </div>
      <table class="table table-striped mt-5">
        <thead>
          <tr>
            <th scope="col">員代</th>
            <th scope="col">視訊連結</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="url != null" >
            <td>{{ user.id_number }}</td>
            <td><a v-bind:href="url">點我連結至視訊</a></td>
          </tr>
        </tbody>
      </table>
      <!-- <div >
        <a v-bind:href="url">點我連結至視訊</a>
      </div> -->
    </form>
  </div>
</template>

<script>
export default {
  methods: {
    search () {
      const api = `${process.env.VUE_APP_API_N}`
      console.log(api)
      console.log(this.user)
      fetch(api, {
        method: 'POST',
        body: JSON.stringify(this.user)
      })
        .then(res => res.json())
        .catch(error => {
          console.error('Error:', error)
        })
        .then(response => {
          console.log('Success:', response)
          this.url = response.url
        })
    }
  },
  data () {
    return {
      user: {
        id_number: '',
        msg: ''
      },
      url: null
    }
  }
}
</script>
